import { Component } from '@angular/core';

@Component({
  selector: 'app-pagina-desconhecida',
  standalone: true,
  imports: [],
  templateUrl: './pagina-desconhecida.component.html',
  styleUrl: './pagina-desconhecida.component.scss'
})
export class PaginaDesconhecidaComponent {

}
